import { useCurrency } from '@/providers/currency-provider';

/**
 * Hook for formatting currency values
 * 
 * Usage:
 * const formatCurrency = useFormatCurrency();
 * formatCurrency(1234.56) // "£1,234.56"
 * formatCurrency(1234.56, { compact: true }) // "£1.2k"
 */
export function useFormatCurrency() {
  const { formatCurrency } = useCurrency();
  return formatCurrency;
}
